/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAuthSignupRequest
 */
export interface PostAuthSignupRequest {
    /**
     * 
     * @type {string}
     * @memberof PostAuthSignupRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof PostAuthSignupRequest
     */
    password: string;
}

/**
 * Check if a given object implements the PostAuthSignupRequest interface.
 */
export function instanceOfPostAuthSignupRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function PostAuthSignupRequestFromJSON(json: any): PostAuthSignupRequest {
    return PostAuthSignupRequestFromJSONTyped(json, false);
}

export function PostAuthSignupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAuthSignupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function PostAuthSignupRequestToJSON(value?: PostAuthSignupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

